var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1430106129"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2662",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white",
    fillOpacity: 0.82
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.252 12.2504V8.75041H11.0853V10.2612L9.28283 8.45874L8.46033 9.28124L10.2628 11.0837H8.75199V12.2504H12.252ZM19.252 12.2504V11.0837H17.7412L19.5437 9.28124L18.7212 8.45874L16.9187 10.2612V8.75041H15.752V12.2504H19.252ZM8.75199 15.7504V16.9171H10.2628L8.46033 18.7196L9.28283 19.5421L11.0853 17.7396V19.2504H12.252V15.7504H8.75199ZM15.752 15.7504V19.2504H16.9187V17.7396L18.7212 19.5421L19.5437 18.7196L17.7412 16.9171H19.252V15.7504H15.752Z",
    fill: "#20C3FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.64b494b6fb2235f9e2ae6efe5b9807f9.svg";
export { ForwardRef as ReactComponent };